import { safeAtomFamily } from 'shared/utils/safe-atom-family';
import { atom } from 'jotai';
import { IUserFollowTopic } from 'shared/models';

export interface IUserFollowTopicData {
  cursor: number;
  hasMore: boolean;
  data: IUserFollowTopic[];
}

type TUserFollowTopicStore = { [key: string]: IUserFollowTopicData };

export const $UserFollowingTopicStore = atom({} as TUserFollowTopicStore);

export const $UserFollowingTopic = safeAtomFamily((userLinkName: string) => {
  const a = atom(
    (get) => {
      return get($UserFollowingTopicStore)[userLinkName];
    },
    (get, set, input: IUserFollowTopicData) => {
      const old = get($UserFollowingTopicStore);

      set($UserFollowingTopicStore, { ...old, [userLinkName]: input });
    },
  );

  a.debugLabel = `$UserFollowingTopic+${encodeURIComponent(userLinkName)}`;

  return a;
});

export const $UserFollowTopicLoadmore = safeAtomFamily((userLinkName: string) => {
  const a = atom(null, (get, set, input: IUserFollowTopicData) => {
    const old = get($UserFollowingTopic(userLinkName));
    set($UserFollowingTopic(userLinkName), {
      ...input,
      data: [...old.data, ...input.data],
    });
  });

  a.debugLabel = `$UserFollowTopicLoadmore+${encodeURIComponent(userLinkName)}`;

  return a;
});
